import { get } from 'lodash';

export default function addScrollingWindow(obj) {
  const res = { ...obj };
  const shortcut1 = get(obj, 'config.interval.shortcut');
  if (shortcut1) {
    if (shortcut1.toLowerCase() !== 'custom') {
      res.config.interval.scrollingWindow = true;
    } else {
      res.config.interval.scrollingWindow = false;
    }
  }
  const shortcut2 = get(obj, 'base.interval.shortcut');
  if (shortcut2) {
    if (shortcut2.toLowerCase() !== 'custom') {
      res.base.interval.scrollingWindow = true;
    } else {
      res.base.interval.scrollingWindow = false;
    }
  }
  return res;
}
